import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const joinWaitlist = async (payload) => {
  const { data } = await axios.post(`${API}/waitlist`, payload);
  return data;
};

export const getWaitlistCount = async () => {
  const { data } = await axios.get(`${API}/waitlist/count`);
  return data.count;
};

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -20, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};
